import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RegistrationCompletePage } from './registration-complete';

@NgModule({
  declarations: [
    RegistrationCompletePage,
  ],
  imports: [
    IonicPageModule.forChild(RegistrationCompletePage),
  ],
})
export class RegistrationCompletePageModule {}



// WEBPACK FOOTER //
// ./src/pages/registration-complete/registration-complete.module.ts